import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from 'Store'
import path, { createRouteObject } from 'Router/path'

import component from 'Components/index'

import customer from 'Router/customer';
import product from 'Router/product';
import invoice from 'Router/invoice';
import profile from 'Router/profile';

import certificateContext, { CertificateState } from "Core/certificates/certificateState";
import { baseUrlFactory } from 'Services/Repository';

export * from 'Router/path'

const routes: RouteRecordRaw[] = [
  createRouteObject({
    path: {
      url: "/"
    },
    component: component.LandingPage
  }, {
    isPublic: true
  }),
  createRouteObject({
    path: path.startup,
    component: component.LandingPage
  }, {
    isPublic: true
  }),
  createRouteObject({
    path: path.login,
    component: component.LoginPage
  }, {
    isPublic: true
  }),
  createRouteObject({
    path: path.dashboard,
    component: component.DashboardPage
  }),
  createRouteObject({
    path: path.notification,
    component: component.NotificationPage
  })
].concat(customer, invoice, profile, product);

routes.push({
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: component.NotFoundPage,
  meta: {
    isPublic: true
  },
  beforeEnter: (e) => {
    if (!e.path.startsWith('/m/')) {
      window.location.href = baseUrlFactory.getProvider().getUrl() + '/page-not-found';
    }
  }
})

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const fixedPath = function (url: string) {
  var regex = new RegExp('//+', 'g');
  url = url.replace(regex, '/');
  return url.startsWith('/m') ? url : `/m${url}`;
}

router.beforeEach((to, from, next) => {
  const toPath = to.path;
  if (toPath.indexOf('//') !== -1) {
    next(fixedPath(toPath));
    return;
  }

  const loginPath = path.login.url;
  const meta = to.meta;
  const loggedIn = store.getters.isAuthorized;
  if (!loggedIn) {
    if (meta.isPublic) {
      next();
      return;
    }
    next(loginPath);
    return;
  }

  if (toPath == loginPath) {
    next(path.dashboard.url);
    return;
  }

  const state = certificateContext.getState();
  switch (state.getState()) {
    case CertificateState.Authorized:
      next();
      break;
    default:
      next(loginPath);
      break;
  }
});

export default router;
